import React from "react"
import Modal from "./modal"
import * as htmlHelper from "../../helpers/html"

export default function SimpleErrorModal({ modalOpen, errorData, closeHandler }) {
  return (
    <Modal
      isOpen={modalOpen}
      closeHandler={closeHandler}
      noScrollToTop="true"
      modifier="modal--wide modal--fixed"
      overlayModifier="ReactModal__Overlay--fixed"
      bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
    >
      <div className="modal__content__inner">
        <div className="modal__top">
          <header className="a--left">
            {errorData.h3 ? <h3 className="headline-md">{htmlHelper.htmlStringToReactElement(errorData.h3)}</h3> : null}
            {errorData.richText ? <div className="rich-text">{htmlHelper.htmlStringToReactElement(errorData.richText)}</div> : null}
          </header>
        </div>
      </div>
    </Modal>
  )
}
